import { Injectable, signal } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { AppAuthService } from '../app/auth.service';
import { RouteData } from '@/models/route-data.model';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket!: Socket;
  private readonly serverUrl = 'https://notificationio.webpubsub.azure.com'; // Your Socket.IO server URL
  private isConnected = signal<boolean>(false);

  constructor(
    private authService: AppAuthService) {
    this.subscribeToLoginStatus();
  }

  private subscribeToLoginStatus(): void {
    // .refactor to use auth0
    // this.msalService.instance.addEventCallback((event) => {
    //   if (event.eventType === 'msal:loginSuccess' || event.eventType === 'msal:acquireTokenSuccess') {
    //     //.refactor to use auth0
    //     // this.connect();
    //   }
    // });
  }

  // private connect(): void {
  //   // console.log('Connecting socket...');
  //   this.authService.getAuthToken().subscribe({
  //     next: (token) => {
  //       this.socket = io(this.serverUrl, {
  //         path: '/clients/socketio/hubs/lexgen',
  //         query: { token }
  //       });

  //       this.socket.on('connect', () => {
  //         // console.log('Socket connected');
  //         this.isConnected.next(true);
  //       });

  //       this.socket.on('connect_error', (error: any) => {
  //         console.error('Socket.IO connection error:', error);
  //       });

  //       this.setupListeners();
  //     },
  //     error: (error: any) => console.error('Error obtaining auth token:', error)
  //   });
  // }

  // private setupListeners(): void {
  //   // console.log('Setting up socket listeners...');
  //   this.socket.on('hello', (data: any) => {
  //   });

  //   this.socket.on('dataReceived', (data: any) => {
  //     this.handleDataReceived(data);
  //   });

  //   this.socket.on('receiveResponse', (resp: string) => {
  //     console.log('Received response:', resp);
  //   });
  // }

  // joinRooms(userId: string, groupIds: string[]): void {
  //   console.log('joining rooms',userId,groupIds);
  //   this.socket.emit("joinRooms", { userId, groupIds });
  // }
  
  // sendMessage(room: string, message: string): void {
  //   console.log('sending in service');
  //   this.socket.emit("sendMessage", { room, message });
  // }

  // sendCommand(room: string, message: string): void {
  //   console.log('sending command in service',room,message);
  //   this.socket.emit("sendCommand", { room, message });
  // }
  
  // receiveMessage(): Observable<string> {
  //   return new Observable<string>((observer) => {
  //     // Wait until the socket is connected before subscribing to the 'receiveMessage' event
  //     this.isConnected.subscribe(connected => {
  //       if (connected) {
  //         this.socket.on("receiveMessage", (message: string) => {
  //           observer.next(message);
  //         });
  //       }
  //     });
  //   });
  // }

  // receiveRoute(): Observable<RouteData> {
  //   return new Observable<RouteData>((observer) => {
  //     // Wait until the socket is connected before subscribing to the 'receiveMessage' event
  //     this.isConnected.subscribe(connected => {
  //       if (connected) {
  //         this.socket.on("route", (route: RouteData) => {
  //           console.log('route:',route);
  //           observer.next(route);
  //         });
  //       }
  //     });
  //   });
  // }

  // receiveNotification(): Observable<UserNotification> {
  //   return new Observable<UserNotification>((observer) => {
  //     // Wait until the socket is connected before subscribing to the 'receiveMessage' event
  //     this.isConnected.subscribe(connected => {
  //       if (connected) {
  //         this.socket.on("notification", (notification: UserNotification) => {
  //           observer.next(notification);
  //         });
  //       }
  //     });
  //   });
  // }

  // private handleDataReceived(data: any): void {
  //   console.log('Data received:', data);
  //   if (data.type === 'search') {
  //     this.handleSearchData(data.payload);
  //   } else {
  //     console.log('Unhandled data type:', data.type);
  //   }
  // }

  // private handleSearchData(payload: any): void {
  //   // Perform the specific function with the payload
  //   console.log('Handling search data:', payload);
  //   this.recentSearchService.setSearches(payload);
  //   // Add your specific function logic here
  // }


  // receiveResponse(): Observable<string> {
  //   return new Observable<string>((observer) => {
  //     this.isConnected.subscribe(connected => {
  //       if (connected) {
  //         this.socket.on("receiveResponse", (resp: string) => {
  //           console.log('Response received:', resp);
  //           observer.next(resp);
  //         });
  //       }
  //     });
  //   });
  // }

  // public disconnect(): void {
  //   if (this.socket) {
  //     console.log('Disconnecting socket...');
  //     this.socket.disconnect();
  //   }
  // }
}
